import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_DYNAMO_API_URL
});

export const axiosInstanceES = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

export const axiosInstanceIMG = axios.create({
    baseURL: process.env.REACT_APP_IMAGE_API_URL
});

export const axiosInstancePayload = axios.create({
    baseURL: process.env.REACT_APP_PAYLOAD_API_URL
});

// updateToken sets the Authorization default only once login has run, but on a
// full page refresh components fetch on mount before that (e.g. the request
// grid's coordinator list got 403 no_token and stayed empty). Fall back to the
// stored token for any call that does not already carry one.
const attachStoredToken = (config) => {
    const hasAuth = config.headers && (config.headers.Authorization || config.headers.authorization);
    if (!hasAuth) {
        let token = null;
        try {
            token = localStorage.getItem('token');
        } catch (e) {
            token = null;
        }
        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
};
axiosInstance.interceptors.request.use(attachStoredToken);
axiosInstanceES.interceptors.request.use(attachStoredToken);
axiosInstanceIMG.interceptors.request.use(attachStoredToken);

export const updateToken = (token)=>{   
        axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
        axiosInstanceES.defaults.headers['Authorization'] = `Bearer ${token}`;
        axiosInstanceIMG.defaults.headers['Authorization'] = `Bearer ${token}`;
}

export const isTokenExpired = (token) => {
    const decoded = parseJwt(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp < currentTime;
}
export const parseJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

export default axiosInstance;
